import type { PayloadAction } from '@reduxjs/toolkit';
import { AddPaymentMethodRequestBody } from '@/domains/payments/features/paymentModals/modals/AddPaymentMethod/types/AddPaymentMethodRequestBody';
import { call, takeLatest } from 'redux-saga/effects';
import { Modals } from '@/features/serviceModal/enums/Modals';
import { SnackType } from '@/features/snacks/enums/SnackType';
import { addPaymentMethod } from '@/domains/payments/features/paymentModals/modals/AddPaymentMethod/store/addPaymentMethod.slice';
import PaymentFormEvent from '@/domains/payments/features/paymentModals/shared/events';
import EventService from '@/services/EventService/EventService';
import HttpService from '@/services/HttpService/HttpService';
import ModalService from '@/services/ModalService/ModalService';
import SnacksService from '@/services/SnackService/SnackService';

function* addPaymentMethodSaga({ payload }: PayloadAction<AddPaymentMethodRequestBody>) {
  try {
    yield call(HttpService.post, '/Payment/add-payment-method', payload, {
      baseURL: import.meta.env.VITE_API_URL,
    });

    SnacksService.add({
      type: SnackType.Success,
      title: 'Payment Information has been updated successfully',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
    ModalService.close(Modals.AddPaymentMethod);
    EventService.dispatch(new PaymentFormEvent.PaymentMethodSuccess({}));
  } catch (error) {
    console.error(error);
    ModalService.close(Modals.AddPaymentMethod);
  } finally {
    EventService.dispatch(new PaymentFormEvent.CreateRequestSuccess({}));
  }
}

export function* addPaymentMethodWatcher() {
  yield takeLatest([addPaymentMethod.type], addPaymentMethodSaga);
}
